module.exports = __webpack_public_path__ + "img/3.ab3e70e8.png";